import React from "react";
import { motion } from "framer-motion";
import { useT } from "../lib/i18n";
import { PERSONAS } from "../lib/personas";

/**
 * The Bubble â€” TAi-P's trademark travel-persona selector. Renders 8 rounded
 * chips; tapping one starts a persona-specific conversation.
 */
export default function PersonaBubbles({ onSelect, active }) {
  const { t } = useT();
  return (
    <div
      data-testid="persona-bubbles"
      className="flex flex-wrap gap-1.5 justify-center md:justify-start"
    >
      {PERSONAS.map((p, i) => {
        const isActive = active === p.key;
        return (
          <motion.button
            key={p.key}
            data-testid={`persona-${p.key}`}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.02 * i, duration: 0.35 }}
            onClick={() => onSelect?.(p)}
            aria-label={t(p.i18n)}
            className={`chip taip-persona-chip flex-none whitespace-nowrap px-3 py-1.5 rounded-full text-[12px] min-[390px]:text-[13px] sm:text-sm font-medium border transition-all backdrop-blur-xl ${
              isActive ? "taip-persona-active" : ""
            }`}
          >
            <span className="mr-1.5">{p.emoji}</span>
            {t(p.i18n)}
          </motion.button>
        );
      })}
    </div>
  );
}

